// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconViewOn = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 25 24', fill: 'none', ...props },
    <path
      d="M23.383 10.882c-2.63-2.89-7-5.95-11.38-5.88-4.41-.09-8.75 2.99-11.38 5.88-.83.92-.83 2.31 0 3.23 2.6 2.86 6.89 5.88 11.21 5.88h.31c4.34 0 8.64-3.03 11.24-5.89.83-.91.83-2.29 0-3.22zm-1.11 2.23c-2.41 2.65-6.35 5.5-10.28 5.39-3.91.09-7.85-2.74-10.25-5.39a.916.916 0 010-1.22c2.38-2.62 6.27-5.39 10.12-5.39h.16c3.89-.09 7.85 2.74 10.25 5.39.31.35.31.87 0 1.22zm-10.27-5.11c-2.48 0-4.5 2.02-4.5 4.5 0 1.2.47 2.33 1.32 3.18.85.85 1.98 1.32 3.18 1.32 2.48 0 4.5-2.02 4.5-4.5 0-1.2-.47-2.33-1.32-3.18a4.471 4.471 0 00-3.18-1.32zm0 7.5c-.8 0-1.56-.31-2.12-.88-.57-.57-.88-1.32-.88-2.12 0-1.65 1.35-3 3-3 .8 0 1.55.31 2.12.88.57.57.88 1.32.88 2.12 0 1.66-1.34 3-3 3z"
      fill="currentColor"
    />
  );
export default SvgIconViewOn;
